import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useStaticQuery, graphql, Link } from "gatsby";
import Helmet from "react-helmet";

import Header from "./header";
import "./layout.css";
import { loadUser } from "../actions/auth";
import { toggleTheme } from "../actions/appearance";

const Layout = (props) => {
  const { loadUser, children, theme } = props;
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  useEffect(() => {
    // Check the user's authentication status on every page
    loadUser();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);
    if (query.get("success")) {
      // alert("Order placed! You will receive an email confirmation.");
    }
    if (query.get("canceled")) {
      // alert(
      //   "Order canceled -- continue to shop around and checkout when you're ready."
      // );
    }
  }, []);

  return (
    <div
      className={
        `min-h-screen flex flex-col bg-body text-inverse ` +
        (theme === `dark` ? `theme-dark` : `theme-light`)
      }
      style={{ maxWidth: `100vw` }}
    >
      <Helmet>
        <script src="https://js.stripe.com/v3/"></script>

        {/* <script src="https://cdn.firebase.com/libs/firebaseui/4.2.0/firebaseui.js"></script> */}
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className="flex-1 flex flex-col h-full">
        <main
          style={{
            margin: `0px auto`,
            maxWidth: 1200,
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0,
          }}
          className="flex-1 w-full"
        >
          {children}
        </main>
        <footer className="text-center mb-1 font-sans">
          © {new Date().getFullYear()} Daniel Schlabach
          <Link className="mx-2" to="/about">
            About
          </Link>
        </footer>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  theme: state.appearance.theme,
});

export default connect(mapStateToProps, { loadUser, toggleTheme })(Layout);
